export default __webpack_public_path__ + "static/media/FraunhoferJoke-EN.91880610.mp4";